<script lang="ts">
import { formateDate } from '@/app/common/dateFormate';
import { AttachmentUploaderType } from '@/app/common/types/attachUploader';
import { ADD_DOCS_STATUS, ADD_DOCS_STATUS_OPTIONS, ATTACH_TYPE, ATTACHMENT_OPTIONS } from '@/app/const';
import UserUpload from '@/components/pages/complaint/detail/userUpload.vue';
import { ComplaintAdditionalDoc } from '@/interface/Complaint.interface';
import { complaintService, fileService, userService } from '@/services/serviceProvider';

export default {
    components: {
        UserUpload
    },
    props: {
        modelValue: {
            type: Array<Object>,
            default: [],
        },
        userMode: {
            type: Boolean,
            default: true
        },
        viewMode: {
            type: Boolean,
            default: false
        },
        showOnlySelfDpm: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup() {
        const fileSv = fileService;
        const userSv = userService;
        return { fileSv, userSv }
    },
    data() {
        return {
            attachmentOptions: ATTACHMENT_OPTIONS,
            additionalDocStatuses: ADD_DOCS_STATUS_OPTIONS,
            displayUserUpload: false,
            selectedIndex: undefined as number | undefined,
            additionalDocSelected: undefined as ComplaintAdditionalDoc | undefined,
            files: [] as any[]
        }
    },
    computed: {
        model: {
            get() {
                if (this.showOnlySelfDpm)
                    return (this.modelValue as ComplaintAdditionalDoc[])
                        .filter(o => o.departmentCode === userService.currentDepartment());
                return this.modelValue as ComplaintAdditionalDoc[];
            },
            set(newValue: any) {
                this.$emit('update:modelValue', newValue);
            }
        },
        headers() {
            return [
                { title: this.$t('t-order'), key: 'index', width: '5%', align: 'center', sortable: false },
                { title: this.$t('t-complaint-additional-docs'), key: 'docName' },
                { title: this.$t('t-complaint-additional-doc-status'), key: 'status', width: '10%' },
                { title: this.$t('t-complaint-request-by-dpm'), key: 'departmentCode', width: '8%' },
                { title: this.$t('t-complaint-request-date'), key: 'requestDateString', width: '12%' },
                { title: this.$t('t-complaint-receive-date'), key: 'receiveDateString', width: '13%' },
                { title: '', key: 'actions', sortable: false, width: '2%' },
            ] as any[];
        },
        headersUser() {
            return [
                { title: this.$t('t-order'), key: 'index', width: '5%', align: 'center', sortable: false },
                { title: this.$t('t-complaint-additional-docs'), key: 'docName' },
                { title: this.$t('t-complaint-additional-doc-status'), key: 'status', width: '10%' },
                { title: this.$t('t-complaint-request-date'), key: 'requestDateString', width: '12%' },
                { title: '', key: 'actions', sortable: false, width: '2%' },
            ] as any[];
        },
        allowUpload() {
            return this.userMode && !this.viewMode;
        },
    },
    methods: {
        edit(index: number) {
            // this.model[index].fileUploads = [];
            // this.model[index].fileUploads.push({ name: 'zsdasd.pdf' } as AttachmentUploaderType);
            this.selectedIndex = index;
            this.additionalDocSelected = this.model[index];
            this.displayUserUpload = true;
        },
        dateString(date: Date) {
            return complaintService.dateString(date);
        },
        statusName(code: string) {
            return this.additionalDocStatuses.find(o => o.value === code)?.label;
        },
        allowView(status: string) {
            return status === ADD_DOCS_STATUS.UPLOADED
                || status === ADD_DOCS_STATUS.COMPLETED;
        },
        attachmentLabel(value: number, remark: string | number | undefined) {
            if (value === 1 || value === 2) {
                return this.$t(`t-${this.attachmentOptions.find(o => o.value === value)?.label}`)
            }
            return `${this.$t(`t-complaint-req-doc-other`)} (${remark})`;
        },
        allAttachments(index: number) {
            let newUploads = this.model[index].fileUploads as any[] ?? [];
            newUploads.forEach(up => { up.type = ATTACH_TYPE.NEW });
            let alreadySaved = this.model[index].attachments as any[] ?? [];
            alreadySaved.forEach(saved => { saved.type = ATTACH_TYPE.SAVED });
            return newUploads.concat(alreadySaved);
        },
        userUploadSuccess(doc: ComplaintAdditionalDoc) {
            if (this.selectedIndex !== undefined) {
                if (doc && (doc.attachments && doc.attachments.length > 0)
                    || (doc.fileUploads && doc.fileUploads.length > 0)) {
                    this.model[this.selectedIndex].fileUploads = doc.fileUploads ? [...doc.fileUploads] : [];
                    this.model[this.selectedIndex].attachments = doc.attachments ? [...doc.attachments] : [];
                    this.model[this.selectedIndex].status = ADD_DOCS_STATUS.UPLOADED;
                } else {
                    this.model[this.selectedIndex].fileUploads = [];
                    this.model[this.selectedIndex].attachments = [];
                    this.model[this.selectedIndex].status = ADD_DOCS_STATUS.APPROVED;
                }
            }
        },
        oneAttachment(item: ComplaintAdditionalDoc): boolean {
            return (item.attachments !== undefined && item.attachments.length === 1)
                || (item.fileUploads !== undefined && item.fileUploads.length === 1)
        },
        showViewFile(item: ComplaintAdditionalDoc) {
            return this.allowView(item.status) && this.oneAttachment(item);
        },
        twoAndMoreAttachment(item: ComplaintAdditionalDoc): boolean {
            return (item.attachments !== undefined && item.attachments.length > 1)
                || (item.fileUploads !== undefined && item.fileUploads.length > 1);
        },
        showListViewFile(item: ComplaintAdditionalDoc) {
            return this.allowView(item.status) && this.twoAndMoreAttachment(item);
        },
        otherFileNames() {
            let allAttachs = [] as any[];
            this.model.forEach((o, index) => {
                if (index !== this.selectedIndex) {
                    o.fileUploads?.forEach(file => {
                        allAttachs.push(file.name);
                    })
                }
            });
            return allAttachs;
        },
        alreadyUpload(item: any) {
            return item.status === ADD_DOCS_STATUS.COMPLETED
        }
    }
}
</script>
<template>
    <v-card class="app-card admin-card">
        <v-toolbar density="compact">
            <v-toolbar-title>{{ $t('t-complaint-additional-docs') }}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table :headers="userSv.isUser() ? headersUser : headers" :items="model" hide-default-footer
                :no-data-text="$t('t-no-data-available')" :items-per-page="-1">
                <template #[`item.index`]="{ index }">
                    <div class="w-100 text-center">{{ index + 1 }}</div>
                </template>
                <template #[`item.docName`]="{ item }">
                    <div class="w-100">{{ attachmentLabel(item.docTypeNo, item.remark) }}</div>
                </template>
                <template #[`item.status`]="{ item }">
                    <v-chip>{{ statusName(item.status) }}</v-chip>
                </template>
                <template #[`item.requestDateString`]="{ item }">
                    <div class="w-100">{{ dateString(item.requestDate) }}</div>
                </template>
                <template #[`item.receiveDateString`]="{ item }">
                    <div class="w-100">{{ item.receiveDate ? dateString(item.receiveDate) : '' }}</div>
                </template>
                <template v-slot:item.actions="{ item, index }">
                    <div class="actions d-flex align-center">
                        <!-- Upload Button -->
                        <!-- Only User: Upload attachment -->
                        <v-btn v-if="allowUpload && !alreadyUpload(item)" variant="text" color="primary"
                            @click="edit(index)">
                            <v-icon icon="mdi mdi-upload" class="mr-1"></v-icon>
                            <span>{{ $t('t-upload-doc') }}</span>
                        </v-btn>
                        <!-- View Button -->
                        <!-- view file when there is only 1 file -->
                        <div v-if="allowUpload">
                            <v-btn v-if="showViewFile(item)" variant="text" color="primary"
                                @click="fileSv.viewFileInEditMode(allAttachments(index)[0])">
                                <v-icon icon="mdi mdi-eye-outline" class="mr-1"></v-icon>
                                <span>{{ $t('t-view-doc') }}</span>
                            </v-btn>
                        </div>
                        <div v-else>
                            <v-btn v-if="showViewFile(item)" variant="text" color="primary"
                                @click="fileSv.viewFileAlreadySaved(allAttachments(index)[0].url, allAttachments(index)[0].fileName)">
                                <v-icon icon="mdi mdi-eye-outline" class="mr-1"></v-icon>
                                <span>{{ $t('t-view-doc') }}</span>
                            </v-btn>
                        </div>
                        <!-- view files in modal when there are two or more files -->
                        <div v-if="allowUpload">
                            <v-menu v-if="showListViewFile(item)">
                                <template v-slot:activator="{ props }">
                                    <v-btn variant="text" color="primary" v-bind="props">
                                        <v-icon icon="mdi mdi-eye-outline" class="mr-1"></v-icon>
                                        <span>{{ $t('t-view-doc') }}</span>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(file, fileIndex) in allAttachments(index)" :key="fileIndex"
                                        :value="fileIndex" @click="fileSv.viewFileInEditMode(file)">
                                        <v-list-item-title>{{ file.name }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                        <div v-else>
                            <v-menu v-if="showListViewFile(item)">
                                <template v-slot:activator="{ props }">
                                    <v-btn variant="text" color="primary" v-bind="props">
                                        <v-icon icon="mdi mdi-eye-outline" class="mr-1"></v-icon>
                                        <span>{{ $t('t-view-doc') }}</span>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(file, index) in item.attachments" :key="index" :value="index"
                                        @click="fileSv.viewFileAlreadySaved(file.url, file.fileName)">
                                        <v-list-item-title>{{ file.fileName }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                        <!-- Edit Button -->
                        <!-- Only User: Edit attachment-->
                        <v-btn v-if="allowUpload && ((item.attachments && item.attachments.length > 0)
                            || (item.fileUploads && item.fileUploads.length > 0)) && !alreadyUpload(item)"
                            variant="text" color="primary" @click="edit(index)">
                            <v-icon icon="mdi mdi-pencil" class="mr-1"></v-icon>
                            <span>{{ $t('t-edit') }}</span>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <UserUpload v-model="displayUserUpload" :additional-doc="additionalDocSelected" :other-file-names="otherFileNames()"
        @on-confirm="userUploadSuccess">
    </UserUpload>
</template>